<template>
    <el-transfer class="filed-transfer" style="margin: 20px;display: flex;" filterable :titles="['字段表', '类型对应字段']"
        v-model="value" :button-texts="['到左边', '到右边']" :props="{
      key: 'value',
      label: 'desc'
    }" :data="filedData">
        <el-button class="transfer-footer" style="margin-right: 10px;" slot="right-footer" type="primary" size="small"
            @click="saveFn">保存</el-button>
    </el-transfer>
</template>

<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    export default {
        props: {
            subObj: Object
        },
        data() {
            return {
                filedData: [],
                value: []
            }
        },
        created() {
            this.queryFn()
            this.init()
        },
        computed: {
            ...mapGetters(['editTemplate'])
        },
        methods: {
            init() {
                //console.log(this.$route)
                this.value = []
                let url = this.$resource.listDityCategoryRelationUsed.replace(
                    '{categoryId}',
                    this.$route.query.id
                )
                this.$axios({
                    url: url,
                    method: 'post'
                })
                    .then(res => {
                        this.$nextTick(() => {
                            let arr = res.data.data
                            if (arr.length > 0) {
                                arr.forEach(e => {
                                    this.value.push(e.id)
                                })
                            }
                            //console.log(this.value, 'value')
                        })
                    })
                    .catch(e => { })
            },
            queryFn() {
                let url = this.$resource.listDityCategoryRelation
                    .replace('{pageNum}', 1)
                    .replace('{pageSize}', 999)
                    .replace('{categoryIdOrName}', '')
                this.$axios({
                    url: url,
                    method: 'post'
                })
                    .then(res => {
                        this.$nextTick(() => {
                            let arr = res.data.data.list
                            for (let i = 0; i < arr.length; i++) {
                                this.filedData.push({
                                    value: arr[i].id,
                                    desc: arr[i].dityName + " " + arr[i].dityCode
                                })
                            }
                        })
                    })
                    .catch(e => { })
            },
            saveFn() {
                //console.log(this.subObj)
                //console.log(this.value)
                let arr = []
                let url = this.$resource.updateDityCategoryRelation.replace(
                    '{categoryId}',
                    this.$route.query.id
                )
                new Set(this.value).forEach(e => {
                    arr.push({
                        categoryId: this.$route.query.id,
                        categoryName: this.subObj.category,
                        dictTypeId: e
                    })
                })

                this.$axios({
                    url: url,
                    method: 'post',
                    data: arr
                }).then(res => {
                    this.init()
                    this.$message.success('保存成功！')
                })
            }
        }
    }
</script>
<style>
    .filed-transfer {
        /* height: calc(100% - 50px); */

        .el-transfer-panel__body,
        .el-transfer-panel{
            width: 270px !important;
            height: 450px !important;
        }
        .el-transfer-panel__list {
            /* height: calc(100% - 70px) !important; */
        }

        .el-transfer-panel .el-transfer-panel__footer {
            text-align: right;
        }

        .el-transfer__buttons {
            .el-button {
                display: block;
                margin-left: 0;

                span {
                    margin: 0;
                }
            }
        }
    }
</style>